import { useEffect, useMemo, useState } from 'react';

export const usePagination = (listIndices: number[], itemsPerPage: number) => {
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => setCurrentPage(1), [listIndices]);

  const paginatedListIndices = useMemo(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return listIndices.slice(indexOfFirstItem, indexOfLastItem);
  }, [currentPage, itemsPerPage, listIndices]);

  return {
    paginationProps: {
      totalItems: listIndices.length,
      itemsPerPage,
      currentPage,
      setCurrentPage,
    },
    paginatedListIndices,
  };
};
